import { render, staticRenderFns } from "./README.md?vue&type=template&id=a3cb47ce&"
import script from "./README.md?vue&type=script&lang=js&"
export * from "./README.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports